export class SortType {
    field: string;
    dir: string;

    constructor(field: string, dir: string) {
        this.field = field;
        this.dir = dir;
    }
}
